/**
 * Контекст для radio-input
 */
export const RADIO_INPUT_CONTEXT = 'ruiRadioInputContext'
export const COMPLEX_SEARCH_SUGGEST_ITEM_CONTEXT =
  'ruiComplexSearchSuggestItemContext'
export const MENU_ITEM_CONTEXT = 'ruiMenuItemContext'
